export const conditionOptionsList: {
  label: string
  volume_label: string
  std_dev_label: string
  value: string
  color: string
  type: string
}[] = [
  {
    label: 'has positively or negatively changed',
    volume_label: 'has positively or negatively changed',
    std_dev_label: '(+/- .75 Std Dev)',
    value: 'Change',
    color: '',
    type: 'outlier',
  },
  {
    label: 'has negatively changed',
    volume_label: 'has negatively changed',
    std_dev_label: '(-.75 Std Dev)',
    value: 'Negative Change',
    color: '',
    type: 'outlier',
  },
  {
    label: 'has positively changed',
    volume_label: 'Slightly Higher',
    std_dev_label: '(+.75 Std Dev)',
    value: 'Positive Change',
    color: '',
    type: 'outlier',
  },
  {
    label: 'is above',
    volume_label: 'is above',
    std_dev_label: '',
    value: 'Above',
    color: '',
    type: 'limit',
  },
  {
    label: 'is below',
    volume_label: 'is below',
    std_dev_label: '',
    value: 'Below',
    color: '',
    type: 'limit',
  },
  {
    label: 'increased by more than',
    volume_label: 'increased by more than',
    std_dev_label: '',
    value: 'Increased',
    color: '',
    type: 'limit',
  },
  {
    label: 'decreased by more than',
    volume_label: 'decreased by more than',
    std_dev_label: '',
    value: 'Decreased',
    color: '',
    type: 'limit',
  },
]

export const outlierAlertsList: {
  label: string
  volume_label: string
  std_dev_label: string
  value: string
  color: string
}[] = [
  {
    label: 'negatively or positively changed',
    volume_label: 'slightly changed',
    std_dev_label: '(+/- .75 Std Dev)',
    value: 'Change',
    color: '',
  },
  {
    label: 'negatively changed',
    volume_label: 'slightly lower',
    std_dev_label: '(-.75 Std Dev)',
    value: 'Negative Change',
    color: '',
  },
  {
    label: 'positively changed',
    volume_label: 'slightly higher',
    std_dev_label: '(+.75 Std Dev)',
    value: 'Positive Change',
    color: '',
  },
]

export const customLimitsList: {
  label: string
  volume_label: string
  std_dev_label: string
  value: string
  color: string
}[] = [
  {
    label: 'above',
    volume_label: 'above',
    std_dev_label: '',
    value: 'Above',
    color: '',
  },
  {
    label: 'below',
    volume_label: 'below',
    std_dev_label: '',
    value: 'Below',
    color: '',
  },
  {
    label: 'increased by more than',
    volume_label: 'increased by more than',
    std_dev_label: '',
    value: 'Increased',
    color: '',
  },
  {
    label: 'decreased by more than',
    volume_label: 'decreased by more than',
    std_dev_label: '',
    value: 'Decreased',
    color: '',
  },
]

export const intervalOptionsList: { label: string; value: string }[] = [
  {
    label: 'Week',
    value: 'Week',
  },
  {
    label: 'Month',
    value: 'Month',
  },
  {
    label: 'Quarter',
    value: 'Quarter',
  },
]

export const alertScopeOptions: {
  label: string
  value: string
  field: string
}[] = [
  {
    label: 'Brands',
    value: 'Brand',
    field: 'brand',
  },
  {
    label: 'Products',
    value: 'Product',
    field: 'product_hierarchy',
  },
  {
    label: 'Sources',
    value: 'Source',
    field: 'source_type',
  },
]
export const promotionalOptions: {
  label: string
  value: string | null
}[] = [
  {
    label: 'All Reviews',
    value: null,
  },
  {
    label: 'Non-Promotional',
    value: 'Not Promotional',
  },
  {
    label: 'Promotional Only',
    value: 'Promotional',
  },
]

export const defaultValues = {
  title: '',
  alert_type: 'Star Rating',
  trigger_type: 'Change',
  time_interval: 'Month',
  alert_scope: 'Brand',
  compare_value: 1,
  reviews_filter: 0,
  is_grouped: true,
  showCompareValue: false,
}
